import en from "./en";
import ru from "./ru";
import zh from "./zh";

export const translations = { en, ru, zh };
export const SUPPORTED_LANGS = ["en", "ru", "zh"];

export function normalizeLang(code) {
  const raw = String(code ?? "").trim().toLowerCase();
  if (!raw) return "en";

  const s = raw.replace(/_/g, "-"); // ru_RU -> ru-RU

  if (s.startsWith("ru")) return "ru";
  if (s.startsWith("en")) return "en";
  if (s.startsWith("zh") || s.startsWith("cn")) return "zh";

  return "en";
}